export function getdata(){
	var obj = {
		headDatas:[
			{
				title:'负债和所有者权益（或股东权益）',
				prop:'title',
				width: "150px",
				custom: true,
				
			},
			{
				title: "期末余额",
				custom: true,
				prop: "cwbbwzx_0_x_1",
				width: "100px",
				
			}, {
			
				title: "上年年末余额",
				prop: "cwbbwzx_0_x_2",
				width: "100px",
				custom: true,
				
			},
		],
		headData: [{
				title: "资产",
				prop: "title",
				width: "150px",
				custom: true,
				
			},
			{
				title: "期末余额",
				prop: "cwbbwzx_0_x_1",
				custom: true,
				width: "100px",
				
			},
			{
				title:'上年年末余额',
				prop:'cwbbwzx_0_x_2',
				width: "100px",
				custom: true,
				
			},
		],
		tableDatas:[
			{
					title:'流动负债：',
					disabledcwbbwzx_0_x_1:false,
					disabledcwbbwzx_0_x_2:false,
					cwbbwzx_0_x_1: {
						cellCode:"cwbbwzx_0_x_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbwzx_0_x_2: {
						cellCode:"cwbbwzx_0_x_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					title:'短期借款',
					disabledcwbbwzx_0_x_1:false,
					disabledcwbbwzx_0_x_2:false,
					cwbbwzx_0_x_1: {
						cellCode:"cwbbwzx_0_1_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbwzx_0_x_2: {
						cellCode:"cwbbwzx_0_1_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'以公允价值计量且其变动计入当期损益的金融负债',
					disabledcwbbwzx_0_x_1:false,
					disabledcwbbwzx_0_x_2:false,
					cwbbwzx_0_x_1: {
						cellCode:"cwbbwzx_0_2_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbwzx_0_x_2: {
						cellCode:"cwbbwzx_0_2_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'衍生金融负债',
					disabledcwbbwzx_0_x_1:false,
					disabledcwbbwzx_0_x_2:false,
					cwbbwzx_0_x_1: {
						cellCode:"cwbbwzx_0_3_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbwzx_0_x_2: {
						cellCode:"cwbbwzx_0_3_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'应付票据',
					disabledcwbbwzx_0_x_1:false,
					disabledcwbbwzx_0_x_2:false,
					cwbbwzx_0_x_1: {
						cellCode:"cwbbwzx_0_4_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbwzx_0_x_2: {
						cellCode:"cwbbwzx_0_4_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'应付账款',
					disabledcwbbwzx_0_x_1:false,
					disabledcwbbwzx_0_x_2:false,
					cwbbwzx_0_x_1: {
						cellCode:"cwbbwzx_0_5_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbwzx_0_x_2: {
						cellCode:"cwbbwzx_0_5_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'预收款项',
					disabledcwbbwzx_0_x_1:false,
					disabledcwbbwzx_0_x_2:false,
					cwbbwzx_0_x_1: {
						cellCode:"cwbbwzx_0_6_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbwzx_0_x_2: {
						cellCode:"cwbbwzx_0_6_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'应付职工薪酬',
					disabledcwbbwzx_0_x_1:false,
					disabledcwbbwzx_0_x_2:false,
					cwbbwzx_0_x_1: {
						cellCode:"cwbbwzx_0_7_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbwzx_0_x_2: {
						cellCode:"cwbbwzx_0_7_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'应交税费',
					disabledcwbbwzx_0_x_1:false,
					disabledcwbbwzx_0_x_2:false,
					cwbbwzx_0_x_1: {
						cellCode:"cwbbwzx_0_8_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbwzx_0_x_2: {
						cellCode:"cwbbwzx_0_8_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'其他应付款',
					disabledcwbbwzx_0_x_1:false,
					disabledcwbbwzx_0_x_2:false,
					cwbbwzx_0_x_1: {
						cellCode:"cwbbwzx_0_9_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbwzx_0_x_2: {
						cellCode:"cwbbwzx_0_9_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'持有待售负债',
					disabledcwbbwzx_0_x_1:false,
					disabledcwbbwzx_0_x_2:false,
					cwbbwzx_0_x_1: {
						cellCode:"cwbbwzx_0_10_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbwzx_0_x_2: {
						cellCode:"cwbbwzx_0_10_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'一年内到期的非流动负债',
					disabledcwbbwzx_0_x_1:false,
					disabledcwbbwzx_0_x_2:false,
					cwbbwzx_0_x_1: {
						cellCode:"cwbbwzx_0_11_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbwzx_0_x_2: {
						cellCode:"cwbbwzx_0_11_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'其他流动负债',
					disabledcwbbwzx_0_x_1:false,
					disabledcwbbwzx_0_x_2:false,
					cwbbwzx_0_x_1: {
						cellCode:"cwbbwzx_0_12_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbwzx_0_x_2: {
						cellCode:"cwbbwzx_0_12_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'流动负债合计',
					disabledcwbbwzx_0_x_1:false,
					disabledcwbbwzx_0_x_2:false,
					cwbbwzx_0_x_1: {},
					cwbbwzx_0_x_2: {},
				},{
					title:'非流动负债：',
					disabledcwbbwzx_0_x_1:false,
					disabledcwbbwzx_0_x_2:false,
					cwbbwzx_0_x_1: {
						cellCode:"cwbbwzx_0_13_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbwzx_0_x_2: {
						cellCode:"cwbbwzx_0_13_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
					
				},{
					title:'长期借款',
					disabledcwbbwzx_0_x_1:false,
					disabledcwbbwzx_0_x_2:false,
					cwbbwzx_0_x_1: {
						cellCode:"cwbbwzx_0_14_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbwzx_0_x_2: {
						cellCode:"cwbbwzx_0_14_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'应付债券',
					disabledcwbbwzx_0_x_1:false,
					disabledcwbbwzx_0_x_2:false,
					cwbbwzx_0_x_1: {
						cellCode:"cwbbwzx_0_15_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbwzx_0_x_2: {
						cellCode:"cwbbwzx_0_15_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:' 其中：优先股',
					disabledcwbbwzx_0_x_1:false,
					disabledcwbbwzx_0_x_2:false,
					cwbbwzx_0_x_1: {
						cellCode:"cwbbwzx_0_16_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbwzx_0_x_2: {
						cellCode:"cwbbwzx_0_16_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'永续债',
					disabledcwbbwzx_0_x_1:false,
					disabledcwbbwzx_0_x_2:false,
					cwbbwzx_0_x_1: {
						cellCode:"cwbbwzx_0_17_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbwzx_0_x_2: {
						cellCode:"cwbbwzx_0_17_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'长期应付款',
					disabledcwbbwzx_0_x_1:false,
					disabledcwbbwzx_0_x_2:false,
					cwbbwzx_0_x_1: {
						cellCode:"cwbbwzx_0_18_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbwzx_0_x_2: {
						cellCode:"cwbbwzx_0_18_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'预计负债',
					disabledcwbbwzx_0_x_1:false,
					disabledcwbbwzx_0_x_2:false,
					cwbbwzx_0_x_1: {
						cellCode:"cwbbwzx_0_19_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbwzx_0_x_2: {
						cellCode:"cwbbwzx_0_19_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'递延收益',
					disabledcwbbwzx_0_x_1:false,
					disabledcwbbwzx_0_x_2:false,
					cwbbwzx_0_x_1: {
						cellCode:"cwbbwzx_0_20_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbwzx_0_x_2: {
						cellCode:"cwbbwzx_0_20_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'递延所得税负债',
					disabledcwbbwzx_0_x_1:false,
					disabledcwbbwzx_0_x_2:false,
					cwbbwzx_0_x_1: {
						cellCode:"cwbbwzx_0_21_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbwzx_0_x_2: {
						cellCode:"cwbbwzx_0_21_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'其他非流动负债',
					disabledcwbbwzx_0_x_1:false,
					disabledcwbbwzx_0_x_2:false,
					cwbbwzx_0_x_1: {
						cellCode:"cwbbwzx_0_22_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbwzx_0_x_2: {
						cellCode:"cwbbwzx_0_22_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'非流动负债合计',
					disabledcwbbwzx_0_x_1:false,
					disabledcwbbwzx_0_x_2:false,
					cwbbwzx_0_x_1: {
						cellCode:"cwbbwzx_0_23_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbwzx_0_x_2: {
						cellCode:"cwbbwzx_0_23_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'负债合计',
					disabledcwbbwzx_0_x_1:false,
					disabledcwbbwzx_0_x_2:false,
					cwbbwzx_0_x_1: {
						cellCode:"cwbbwzx_0_24_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbwzx_0_x_2: {
						cellCode:"cwbbwzx_0_24_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'所有者权益（或股东权 益）：',
					disabledcwbbwzx_0_x_1:false,
					disabledcwbbwzx_0_x_2:false,
					cwbbwzx_0_x_1: {
						cellCode:"cwbbwzx_0_25_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbwzx_0_x_2: {
						cellCode:"cwbbwzx_0_25_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'实收资本（或股本）',
					disabledcwbbwzx_0_x_1:false,
					disabledcwbbwzx_0_x_2:false,
					cwbbwzx_0_x_1: {
						cellCode:"cwbbwzx_0_26_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbwzx_0_x_2: {
						cellCode:"cwbbwzx_0_26_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'其他权益工具',
					disabledcwbbwzx_0_x_1:false,
					disabledcwbbwzx_0_x_2:false,
					cwbbwzx_0_x_1: {
						cellCode:"cwbbwzx_0_27_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbwzx_0_x_2: {
						cellCode:"cwbbwzx_0_27_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:' 其中：优先股',
					disabledcwbbwzx_0_x_1:false,
					disabledcwbbwzx_0_x_2:false,
					cwbbwzx_0_x_1: {
						cellCode:"cwbbwzx_0_28_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbwzx_0_x_2: {
						cellCode:"cwbbwzx_0_28_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'永续债',
					disabledcwbbwzx_0_x_1:false,
					disabledcwbbwzx_0_x_2:false,
					cwbbwzx_0_x_1: {
						cellCode:"cwbbwzx_0_28_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbwzx_0_x_2: {
						cellCode:"cwbbwzx_0_28_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'资本公积',
					disabledcwbbwzx_0_x_1:false,
					disabledcwbbwzx_0_x_2:false,
					cwbbwzx_0_x_1: {
						cellCode:"cwbbwzx_0_28_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbwzx_0_x_2: {
						cellCode:"cwbbwzx_0_28_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'减：库存股',
					disabledcwbbwzx_0_x_1:false,
					disabledcwbbwzx_0_x_2:false,
					cwbbwzx_0_x_1: {
						cellCode:"cwbbwzx_0_28_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbwzx_0_x_2: {
						cellCode:"cwbbwzx_0_28_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'其他综合收益',
					disabledcwbbwzx_0_x_1:false,
					disabledcwbbwzx_0_x_2:false,
					cwbbwzx_0_x_1: {
						cellCode:"cwbbwzx_0_28_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbwzx_0_x_2: {
						cellCode:"cwbbwzx_0_28_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'专项储备',
					disabledcwbbwzx_0_x_1:false,
					disabledcwbbwzx_0_x_2:false,
					cwbbwzx_0_x_1: {
						cellCode:"cwbbwzx_0_28_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbwzx_0_x_2: {
						cellCode:"cwbbwzx_0_28_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'盈余公积',
					disabledcwbbwzx_0_x_1:false,
					disabledcwbbwzx_0_x_2:false,
					cwbbwzx_0_x_1: {
						cellCode:"cwbbwzx_0_28_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbwzx_0_x_2: {
						cellCode:"cwbbwzx_0_28_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'未分配利润',
					disabledcwbbwzx_0_x_1:false,
					disabledcwbbwzx_0_x_2:false,
					cwbbwzx_0_x_1: {
						cellCode:"cwbbwzx_0_28_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbwzx_0_x_2: {
						cellCode:"cwbbwzx_0_28_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'所有者权益（或股东权 益）合计',
					disabledcwbbwzx_0_x_1:false,
					disabledcwbbwzx_0_x_2:false,
					cwbbwzx_0_x_1: {
						cellCode:"cwbbwzx_0_28_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbwzx_0_x_2: {
						cellCode:"cwbbwzx_0_28_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'负债和所有者权益（或股东权益）总计',
					disabledcwbbwzx_0_x_1:false,
					disabledcwbbwzx_0_x_2:false,
					cwbbwzx_0_x_1: {
						cellCode:"cwbbwzx_0_29_3",
						cellType:"0",
						cellVal:"240040043.08"
					},
					cwbbwzx_0_x_2: {
						cellCode:"cwbbwzx_0_29_3",
						cellType:"0",
						cellVal:"240040043.08"
					},
				}
			
		],
		tableData: [{
				title: "流动资产：",
				disabledcwbbwzx_0_x_1:false,
				disabledcwbbwzx_0_x_2:false,
				cwbbwzx_0_x_1: {},
				cwbbwzx_0_x_2: {},
			},
			{
				title: "货币资金",
				disabledcwbbwzx_0_x_1:false,
				disabledcwbbwzx_0_x_2:false,
				cwbbwzx_0_x_1: {
					cellCode:"cwbbwzx_0_1_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_0_x_2: {
					cellCode:"cwbbwzx_0_1_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "以公允价值计量且其变动计入当期损益的金融资产",
				disabledcwbbwzx_0_x_1:false,
				disabledcwbbwzx_0_x_2:false,
				cwbbwzx_0_x_1: {
					cellCode:"cwbbwzx_0_2_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_0_x_2: {
					cellCode:"cwbbwzx_0_2_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "衍生金融资产",
				disabledcwbbwzx_0_x_1:false,
				disabledcwbbwzx_0_x_2:false,
				cwbbwzx_0_x_1: {
					cellCode:"cwbbwzx_0_3_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_0_x_2: {
					cellCode:"cwbbwzx_0_3_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "应收票据",
				disabledcwbbwzx_0_x_1:false,
				disabledcwbbwzx_0_x_2:false,
				cwbbwzx_0_x_1: {
					cellCode:"cwbbwzx_0_4_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_0_x_2: {
					cellCode:"cwbbwzx_0_4_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "应收账款",
				disabledcwbbwzx_0_x_1:false,
				disabledcwbbwzx_0_x_2:false,
				cwbbwzx_0_x_1: {
					cellCode:"cwbbwzx_0_5_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_0_x_2: {
					cellCode:"cwbbwzx_0_5_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "预付款项",
				disabledcwbbwzx_0_x_1:false,
				disabledcwbbwzx_0_x_2:false,
				cwbbwzx_0_x_1: {
					cellCode:"cwbbwzx_0_6_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_0_x_2: {
					cellCode:"cwbbwzx_0_6_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "其他应收款",
				disabledcwbbwzx_0_x_1:false,
				disabledcwbbwzx_0_x_2:false,
				cwbbwzx_0_x_1: {
					cellCode:"cwbbwzx_0_7_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_0_x_2: {
					cellCode:"cwbbwzx_0_7_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "存货",
				disabledcwbbwzx_0_x_1:false,
				disabledcwbbwzx_0_x_2:false,
				cwbbwzx_0_x_1: {
					cellCode:"cwbbwzx_0_8_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_0_x_2: {
					cellCode:"cwbbwzx_0_8_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "持有待售资产",
				disabledcwbbwzx_0_x_1:false,
				disabledcwbbwzx_0_x_2:false,
				cwbbwzx_0_x_1: {
					cellCode:"cwbbwzx_0_9_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_0_x_2: {
					cellCode:"cwbbwzx_0_9_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "一年内到期的非流动资产",
				disabledcwbbwzx_0_x_1:false,
				disabledcwbbwzx_0_x_2:false,
				cwbbwzx_0_x_1: {
					cellCode:"cwbbwzx_0_10_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_0_x_2: {
					cellCode:"cwbbwzx_0_10_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "其他流动资产",
				disabledcwbbwzx_0_x_1:false,
				disabledcwbbwzx_0_x_2:false,
				cwbbwzx_0_x_1: {
					cellCode:"cwbbwzx_0_11_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_0_x_2: {
					cellCode:"cwbbwzx_0_11_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "流动资产合计",
				disabledcwbbwzx_0_x_1:false,
				disabledcwbbwzx_0_x_2:false,
				cwbbwzx_0_x_1: {
					cellCode:"cwbbwzx_0_12_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_0_x_2: {
					cellCode:"cwbbwzx_0_12_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "非流动资产：",
				disabledcwbbwzx_0_x_1:false,
				disabledcwbbwzx_0_x_2:false,
				cwbbwzx_0_x_1: {},
				cwbbwzx_0_x_2: {},
			},{
				title: "可供出售金融资产",
				disabledcwbbwzx_0_x_1:false,
				disabledcwbbwzx_0_x_2:false,
				cwbbwzx_0_x_1: {
					cellCode:"cwbbwzx_0_13_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_0_x_2: {
					cellCode:"cwbbwzx_0_13_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
				
			},{
				title: "持有至到期投资",
				disabledcwbbwzx_0_x_1:false,
				disabledcwbbwzx_0_x_2:false,
				cwbbwzx_0_x_1: {
					cellCode:"cwbbwzx_0_14_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_0_x_2: {
					cellCode:"cwbbwzx_0_14_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "长期应收款",
				disabledcwbbwzx_0_x_1:false,
				disabledcwbbwzx_0_x_2:false,
				cwbbwzx_0_x_1: {
					cellCode:"cwbbwzx_0_15_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_0_x_2: {
					cellCode:"cwbbwzx_0_15_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "长期股权投资",
				disabledcwbbwzx_0_x_1:false,
				disabledcwbbwzx_0_x_2:false,
				cwbbwzx_0_x_1: {
					cellCode:"cwbbwzx_0_16_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_0_x_2: {
					cellCode:"cwbbwzx_0_16_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "投资性房地产",
				disabledcwbbwzx_0_x_1:false,
				disabledcwbbwzx_0_x_2:false,
				cwbbwzx_0_x_1: {
					cellCode:"cwbbwzx_0_17_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_0_x_2: {
					cellCode:"cwbbwzx_0_17_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "固定资产",
				disabledcwbbwzx_0_x_1:false,
				disabledcwbbwzx_0_x_2:false,
				cwbbwzx_0_x_1: {
					cellCode:"cwbbwzx_0_18_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_0_x_2: {
					cellCode:"cwbbwzx_0_18_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "在建工程",
				disabledcwbbwzx_0_x_1:false,
				disabledcwbbwzx_0_x_2:false,
				cwbbwzx_0_x_1: {
					cellCode:"cwbbwzx_0_19_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_0_x_2: {
					cellCode:"cwbbwzx_0_19_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "生产性生物资产",
				disabledcwbbwzx_0_x_1:false,
				disabledcwbbwzx_0_x_2:false,
				cwbbwzx_0_x_1: {
					cellCode:"cwbbwzx_0_20_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_0_x_2: {
					cellCode:"cwbbwzx_0_20_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "油气资产",
				disabledcwbbwzx_0_x_1:false,
				disabledcwbbwzx_0_x_2:false,
				cwbbwzx_0_x_1: {
					cellCode:"cwbbwzx_0_21_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_0_x_2: {
					cellCode:"cwbbwzx_0_21_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "无形资产",
				disabledcwbbwzx_0_x_1:false,
				disabledcwbbwzx_0_x_2:false,
				cwbbwzx_0_x_1: {
					cellCode:"cwbbwzx_0_22_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_0_x_2: {
					cellCode:"cwbbwzx_0_22_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "开发支出",
				disabledcwbbwzx_0_x_1:false,
				disabledcwbbwzx_0_x_2:false,
				cwbbwzx_0_x_1: {
					cellCode:"cwbbwzx_0_23_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_0_x_2: {
					cellCode:"cwbbwzx_0_23_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "商誉",
				disabledcwbbwzx_0_x_1:false,
				disabledcwbbwzx_0_x_2:false,
				cwbbwzx_0_x_1: {
					cellCode:"cwbbwzx_0_24_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_0_x_2: {
					cellCode:"cwbbwzx_0_24_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "  长摊待摊费用",
				disabledcwbbwzx_0_x_1:false,
				disabledcwbbwzx_0_x_2:false,
				cwbbwzx_0_x_1: {
					cellCode:"cwbbwzx_0_25_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_0_x_2: {
					cellCode:"cwbbwzx_0_25_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "递延所得税资产",
				disabledcwbbwzx_0_x_1:false,
				disabledcwbbwzx_0_x_2:false,
				cwbbwzx_0_x_1: {
					cellCode:"cwbbwzx_0_26_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_0_x_2: {
					cellCode:"cwbbwzx_0_26_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "其他非流动资产",
				disabledcwbbwzx_0_x_1:false,
				disabledcwbbwzx_0_x_2:false,
				cwbbwzx_0_x_1: {
					cellCode:"cwbbwzx_0_27_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_0_x_2: {
					cellCode:"cwbbwzx_0_27_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "非流动资产合计",
				disabledcwbbwzx_0_x_1:false,
				disabledcwbbwzx_0_x_2:false,
				cwbbwzx_0_x_1: {
					cellCode:"cwbbwzx_0_28_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_0_x_2: {
					cellCode:"cwbbwzx_0_28_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "",
				disabledcwbbwzx_0_x_1:true,
				disabledcwbbwzx_0_x_2:true,
				cwbbwzx_0_x_1: {},
				cwbbwzx_0_x_2: {},
			},{
				title: "",
				disabledcwbbwzx_0_x_1:true,
				disabledcwbbwzx_0_x_2:true,
				cwbbwzx_0_x_1: {},
				cwbbwzx_0_x_2: {},
			},{
				title: "",
				disabledcwbbwzx_0_x_1:true,
				disabledcwbbwzx_0_x_2:true,
				cwbbwzx_0_x_1: {},
				cwbbwzx_0_x_2: {},
			},{
				title: "",
				disabledcwbbwzx_0_x_1:true,
				disabledcwbbwzx_0_x_2:true,
				cwbbwzx_0_x_1: {},
				cwbbwzx_0_x_2: {},
			},{
				title: "",
				disabledcwbbwzx_0_x_1:true,
				disabledcwbbwzx_0_x_2:true,
				cwbbwzx_0_x_1: {},
				cwbbwzx_0_x_2: {},
			},{
				title: "",
				disabledcwbbwzx_0_x_1:true,
				disabledcwbbwzx_0_x_2:true,
				cwbbwzx_0_x_1: {},
				cwbbwzx_0_x_2: {},
			},{
				title: "",
				disabledcwbbwzx_0_x_1:true,
				disabledcwbbwzx_0_x_2:true,
				cwbbwzx_0_x_1: {},
				cwbbwzx_0_x_2: {},
			},{
				title: "",
				disabledcwbbwzx_0_x_1:true,
				disabledcwbbwzx_0_x_2:true,
				cwbbwzx_0_x_1: {},
				cwbbwzx_0_x_2: {},
			},{
				title: "资产总计",
				disabledcwbbwzx_0_x_1:false,
				disabledcwbbwzx_0_x_2:false,
				cwbbwzx_0_x_1: {
					cellCode:"cwbbwzx_0_29_3",
					cellType:"0",
					cellVal:"240040043.08"
				},
				cwbbwzx_0_x_2: {
					cellCode:"cwbbwzx_0_29_3",
					cellType:"0",
					cellVal:"240040043.08"
				},
			}
		]
	}
	return obj
}


